import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
export const KeyShortcut = /*#__PURE__*/ memo((param)=>{
    let { icon: Icon, text, children } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center justify-between py-2",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center",
                children: [
                    !!Icon && /*#__PURE__*/ _jsx(Icon, {
                        className: "size-4 text-grey-10"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "ml-2 text-14 text-grey-11",
                        children: text
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex [&>div]:ml-0.5",
                children: children
            })
        ]
    });
});
KeyShortcut.displayName = "KeyShortcut";
